import {TruckStub} from "../rpc/webrpc-client.gen.ts";
import {TileProps} from "../components/Tile.tsx";
import {useTruckStatus} from "./truck.tsx";
import {useMemo} from "react";
import {pendingUseResult} from "../util/hookutil.tsx";

export function useTruckCrewPresences(args ?: {truckId: string}) {
    const tqrv = useTruckStatus(args);
    const rv = useMemo(() => {
        if (tqrv.isPending) {
            return pendingUseResult;
        }
        return {
            data: tqrv.data.currentCrew,
            isSuccess: true
        };
    }, [tqrv.data?.currentCrew, tqrv.isPending]);
    return rv;
}

// export function useTruckCrewPresenceCapsules({truckId, ...rest}: LimitedUseQueryOptions<{ truckId: string }>):
//     LimitedUseQueryResult<ReactNode[]> {
//     const {data: truckStatus} = useTruckStatus({truckId, ...rest});
//      const rv = useMemo(() => {
//          if (!rest.enabled || !truckStatus) {
//              return MADA;
//          }
//          return {
//             data: truckStatus.currentCrew.map(crew =>
//                 <AgentPresenceCapsule presence={{...crew}} icon={{icon: faSteeringWheel}} key={crew.agent.id}/>),
//             isSuccess: true
//         };
//     }, [rest.enabled, truckStatus]);
//     return rv;
// }

export interface TruckTileProps extends Omit<TileProps, "Subject"> {
    truckStub: TruckStub;
    // showDriver?: boolean;
    // showBundles?: boolean;
    // showLocation?: boolean;
}

// export const StyledTruckTile = styled(Sheet)
//     <
//     {ownerState: TruckTileProps} > (
//         ({theme, ownerState}) => {
//             const paletteName = ownerState.color ?? "neutral";
//             const palette = theme.palette[paletteName];
//             const variant = ownerState.variant ?? "outlined";
//             const variantSpecific = (variant: (typeof ownerState.variant)) => {
//                 switch (variant) {
//                     case "outlined":
//                         return {
//                             borderWidth: 4,
//                             borderColor: palette.outlinedBorder,
//                             borderRadius: "12px",
//                         };
//                 }
//                 return {};
//             };
//             return {
//                 ...TILE_SX,
//                 ...variantSpecific(variant),
//             };
//         });
//
// export function TruckTile(props: TruckTileProps) {
//     const {
//         truck,
//         color,
//         variant: inVariant,
//         showDriver,
//         showBundles,
//         showLocation,
//         actions,
//         ...rest
//     } = props;
//     const {t} = useTranslation();
//     const mama = useMothership();
//     const truckId = truck.id;
//     const {data: truckStatus, isSuccess: isTruckStatusSuccess}
//         = useTruckStatus({truckId});
//     const {data: openTransfersData}
//         = useRefreshableQuery({
//         ...watchOpenBundleTransfersForTruckTqo(mama, {truckId}),
//         enabled: showBundles,
//     });
//     const openTransferStubs = openTransfersData?.transfers ?? NADA;
//     const bxTransfers
//         = useBundleExpandedTransfers({transferStubs: openTransferStubs});
//     const theme = useTheme();
//     const oyaVariant = inVariant ?? "plain";
//     const childVariant = oyaVariant === "outlined" ? "plain" : oyaVariant;
//     const {bgColor} = figureColors({
//         theme, color: color, variant: oyaVariant, invertedColors: props.invertedColors
//     });
//     // eslint-disable-next-line @typescript-eslint/no-misused-spread
//     const topSx = {...rest.sx, fontSize: theme.fontSize.xl};
//     // eslint-disable-next-line @typescript-eslint/no-misused-spread
//     const lowSx = {...rest.sx, fontSize: theme.fontSize.md};
//
//     if (!isTruckStatusSuccess) {
//         return null;
//     }
//
//     return <StyledTruckTile ownerState={props} variant={oyaVariant} color={color}>
//         <CardContent>
//             <Stack direction="column" spacing={0.4} sx={{alignItems: "center", bgcolor: bgColor}}>
//                 <Box sx={{pb: 1.2, width: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
//                     <TruckCapsule truck={truck} variant={childVariant} sx={topSx}
//                                   linkify={true}
//                                   color={color}/>
//                 </Box>
//                 {showLocation
//                     ? <Stack direction="row" sx={{alignItems: "baseline"}}>
//                         <Box sx={{flex: 0, mr: 0.6}}>{t("driver.placeLabel")}</Box>
//                         {truckStatus.currentPlace
//                             ? <VenueCapsule venue={truckStatus.currentPlace}/>
//                             : "???"}
//                     </Stack>
//                     : null}
//                 {showDriver
//                     ? truckStatus.currentCrew.map(crew =>
//                         <AgentPresenceCapsule
//                             presence={{...crew}} icon={{icon: faSteeringWheel}} key={crew.agent.id}
//                             variant={childVariant} sx={lowSx}/>)
//                     : null}
//                 {showBundles
//                     ? bxTransfers.map(bxTransfer => {
//                         if (bxTransfer.bundle) {
//                             return <ActiveBundleCapsule bundle={bxTransfer.bundle} key={bxTransfer.bundle.id}
//                                                         color={color} variant={childVariant} sx={lowSx}
//                                                         linkify={true}/>;
//                         } else {
//                             return null;
//                         }
//                     }) : null}
//             </Stack>
//         </CardContent>
//         {actions ?? null}
//     </StyledTruckTile>
// }
//
